import { useEffect, useState } from "react";
import { apiGet } from "@/lib/api";
import { useNow, localTimeKey } from "@/lib/terminalUtils";

const dot = { valid: "bg-buy", sweep: "bg-emerald-400", mss: "bg-brand", displacement: "bg-warn", invalidated: "bg-sell" };

export const LiveMonitor = () => {
  const [items, setItems] = useState([]);
  const now = useNow(5000);

  useEffect(() => {
    let alive = true;
    const load = () => apiGet("/events").then((r) => alive && setItems(r.data.items)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const hhmmss = (iso) => iso ? localTimeKey(iso) : "—";
  const clock = localTimeKey(now);

  return (
    <div className="flex h-full flex-col border border-white/10 bg-[#0d1219]" data-testid="live-monitor">
      <p className="border-b border-white/10 px-4 py-3 font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">
        Live Market Monitor
      </p>
      <div className="max-h-[420px] flex-1 space-y-2.5 overflow-y-auto p-4 font-mono text-[11px]">
        <div className="flex items-center justify-between gap-2">
          <span className="text-mute-dim">{clock}</span>
          <span className="flex-1 truncate text-mute">Monitoring market...</span>
          <span className="h-2 w-2 rounded-full bg-mute-dim" />
        </div>
        {items.map((ev) => (
          <div key={ev.id} className="flex items-center justify-between gap-2" data-testid={`event-${ev.kind}`}>
            <span className="text-mute-dim">{hhmmss(ev.created_at)}</span>
            <span className={`flex-1 truncate ${ev.kind === "valid" ? "font-bold text-buy" : "text-mute"}`}>
              <span className="mr-1 text-mute-dim">[{ev.symbol}]</span>{ev.text}
            </span>
            <span className={`h-2 w-2 shrink-0 rounded-full ${dot[ev.kind] || "bg-mute-dim"}`} />
          </div>
        ))}
        {items.length === 0 && (
          <p className="text-mute-dim">belum ada event terdeteksi — engine memindai tiap 30 detik</p>
        )}
      </div>
    </div>
  );
};
